import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fileViewLabel: {
    id: 'frontbucket.repository.pullRequest.tabs.diff.fileViewLabel',
    description: 'Label for the file view region',
    defaultMessage: 'File view',
  },
  toggleFileView: {
    id: 'frontbucket.repository.pullRequest.tabs.diff.toggleFileView',
    description: 'Toggle file view button',
    defaultMessage: 'Toggle file view',
  },
});
